// extracted by mini-css-extract-plugin
export default {"Container":"KdYTqn1C","Content":"FZeR7VpF","FooterWrapper":"Ic23ArwZ","Footer":"Kzka38ol","Button":"G4jZqMaJ","Cancel":"L9VtmcpH","isMobile":"ReCHJ6Iz"};